module.exports = __webpack_public_path__ + "img/icon-red-circle-warning.c1a9a9d0.svg";